import { Injectable, Injector } from '@angular/core';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService {

  constructor(private injector: Injector) { }
  intercept(req, next) {
      const restService = this.injector.get(RestService);
      const token = req.clone({
          setHeaders: {
              authorization: restService.getToken() != null ? restService.getToken() : 'null',
          },
      });
      return next.handle(token);
  }
}
